import {Notification, NotificationType} from 'pepsico-ds'
import {useEffect} from 'react'

/**
 * Alert component to display different types of alert messages.
 *
 * @param {Object} props - The properties object.
 * @param {'success' | 'error' | 'info' | 'warning'} props.type - The type of alert to display.
 * @param {string} props.message - The message to display in the alert.
 * @param {boolean} [props.show=false] - Whether the alert is visible or not.
 * @param {Function} props.onCloseClick - The function to call when the close button is clicked.
 *
 * @returns {JSX.Element|null} The Alert component or null if not visible.
 */
const Alert = ({type, message, show = false, onCloseClick}) => {
  useEffect(() => {
    if (!show) {
      return undefined
    }

    const itv = setTimeout(() => onCloseClick?.(), 5000)
    return () => clearTimeout(itv)
  }, [message, onCloseClick, show, type])

  if (!show) {
    return null
  }

  const notificationTypeMap = {
    success: NotificationType.SUCCESS,
    error: NotificationType.ERROR,
    info: NotificationType.INFO,
    warning: NotificationType.WARNING,
  }

  return (
    <Notification
      className="alert absolute right-4 top-6 z-40 w-full max-w-[calc(100vw-7.5rem)]"
      data-testid={`alert-${type}`}
      role="alert"
      type={notificationTypeMap[type]}
      title={message || ''}
      showText={false}
      showActionButtons={false}
    />
  )
}

export default Alert
